import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=f59214f6&scoped=true&"
import script from "./HistoryItem.vue?vue&type=script&lang=js&"
export * from "./HistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&id=f59214f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59214f6",
  null
  
)

export default component.exports